import { useContext } from 'react';
import { shouldShowLastUsedAuthMethod } from '../../stores/constants';
import {
  AuthMethod,
  getLastUsedAuthMethod,
} from '../../utils/lastUsedAuthMethod';
import { AppContextProvider } from '../AppLoader';

/**
 * Whether the control for `method` should carry the "Last used" marker.
 *
 * Shared by every surface that can be badged — the social buttons and the
 * email field — so they cannot drift apart on the toggle, the hint or the
 * comparison.
 */
export const useShouldShowLastUsedBadge = (method?: AuthMethod): boolean => {
  const {
    rootStore: { experiments },
  } = useContext(AppContextProvider);

  return (
    shouldShowLastUsedAuthMethod(experiments) &&
    !!method &&
    method === getLastUsedAuthMethod()
  );
};
